import {VideoTileSkeletonContainerDefaultBox} from "./video-tile-skeleton-container-default.box";

export const VideoTileSkeletonContainerBox = VideoTileSkeletonContainerDefaultBox;
